module.exports = __webpack_public_path__ + "img/cover20.7630c0db.png";